import { render, staticRenderFns } from "./reMessage.vue?vue&type=template&id=f996b63c&scoped=true&"
import script from "./reMessage.vue?vue&type=script&lang=ts&"
export * from "./reMessage.vue?vue&type=script&lang=ts&"
import style0 from "./reMessage.vue?vue&type=style&index=0&id=f996b63c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f996b63c",
  null
  
)

export default component.exports